import { Injectable } from '@angular/core';
import { DefaultSoapSettings } from '../../util/soap-config.constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { ScreeningTerm, PreferenceRef, PreferenceResponse, PreferenceType } from '../../models/soap-config.interface';
import { Observable, catchError, map, of } from 'rxjs';
import { CVA_CONSTANTS } from '../../util/constants';

@Injectable({
  providedIn: 'root'
})
export class UserPreferenceService {

  constructor(private readonly  http: HttpClient) { }

  saveSoapSettings(setting: PreferenceRef): Observable<{ response: PreferenceResponse }> {
    return this.http.post<{ response: PreferenceResponse }>(environment.cva_url + API_ROUTES.USER_SETTING, setting)
  }

  updateSoapSetting(uid: string, preference: PreferenceType): Observable<{ response: PreferenceResponse }> {
    return this.http.patch<{ response: PreferenceResponse }>(environment.cva_url + API_ROUTES.USER_SETTING, preference, { params: { uid } })
  }

  getSoapSettings(referenceId: string, preference_type: string): Observable<PreferenceResponse> {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const params: any = {
      referenceId,
      preference_type
    };
    return this.http.get<{ response: PreferenceResponse[] }>(environment.cva_url + API_ROUTES.USER_SETTING, { params }).pipe(
      map(response => {
        if (response.response.length > 0) {
          return response.response[0];
        } else {
          params.uid = "";
          params.preference = {};
          if (preference_type != CVA_CONSTANTS.CONSTS.soap_setting) {
            return params;
          } else {
            params.preference = DefaultSoapSettings;
            return params;
          }
        }
      }),
      catchError(() => {
        params.preference = DefaultSoapSettings;
        return of(params)
      }))
  }

  getScreeingTermList(): Observable<ScreeningTerm[]> {
    return this.http.get<{ response: ScreeningTerm[] }>(environment.cva_url + API_ROUTES.USER_SETTING + "/screening-terms").pipe(
      map(response => {
        return response.response
      })
    )
  }
}
